






































import { Component, Vue, Prop } from 'vue-property-decorator'
import SettingsCard from '@/components/WorkspaceSettings/SettingsCard.vue'
import AjaxButton from '@/components/AjaxButton.vue'
import ConfirmationMessage from '@/components/WorkspaceSettings/ConfirmationMessage.vue'
import SettingsInput from '@/components/WorkspaceSettings/SettingsInput.vue'
import { SettingsSubmissionData, SettingsSubmissionResponse, SettingsConfirmation, RequestUserResponse, InviteUserResponse, InviteFormFields } from '@/views/WorkspaceSettings.vue'

@Component({
  name: 'InviteUser',
  components: { AjaxButton, ConfirmationMessage, SettingsCard, SettingsInput }
})
export default class InviteUser extends Vue {
  @Prop({ default: () => false }) isAdmin!: boolean
  @Prop({ required: true }) clientid!: string

  inviteUser: InviteFormFields = {
    newUsersEmail: '',
    newUsersFirstName: '',
    newUsersLastName: ''
  }

  errors = {
    newUsersEmail: false,
    newUsersFirstName: false,
    newUsersLastName: false
  }

  confirmation: SettingsConfirmation = {
    status: false,
    msg: ''
  }

  submitting: boolean = false

  submit () {
    if (!this.validate()) {
      setTimeout(() => {
        // @ts-ignore
        this.$refs.saveButton.finish()
      }, 0)
      return
    }
    if (!this.submitting) {
      this.confirmation.status = false
      this.submitting = true
      var submitObj: SettingsSubmissionData = {
        component: this,
        section: 'invite',
        data: {
          isAdmin: this.isAdmin,
          clientid: this.clientid,
          email: this.inviteUser.newUsersEmail.trim().toLowerCase(),
          firstname: this.inviteUser.newUsersFirstName.trim(),
          lastname: this.inviteUser.newUsersLastName.trim(),
          permissions: 'basic_user'
        }
      }
      this.$emit('submit', submitObj)
    }
  }

  finish (confirmation: RequestUserResponse|InviteUserResponse|SettingsSubmissionResponse) {
    const that = this
    if ((confirmation as SettingsSubmissionResponse).status === 'failure') {
      const { msg, status } = confirmation as SettingsSubmissionResponse
      this.confirmation = {
        msg,
        status
      }
    } else {
      // if (confirmation.type === 'new' && window.analytics) {
      //   window.analytics.identify(confirmation.user['id'], {
      //     name: this.inviteUser.newUsersFirstName + ' ' + this.inviteUser.newUsersLastName,
      //     email: this.inviteUser.newUsersEmail,
      //     admin: false,
      //     company: {
      //       id: this.clientid
      //     }
      //   }, { Intercom: { hideDefaultLauncher: true } }
      //   )
      // }
      const { msg, type } = confirmation as InviteUserResponse
      this.confirmation = {
        msg,
        status: type
      }
      if (this.confirmation.status !== 'error') {
        this.$emit('add-user', confirmation)
        setTimeout(function () {
          that.$set(that.confirmation, 'status', false)
        }, 3000)
        // Clear the fields
        Object.keys(this.inviteUser).forEach((key) => {
          this.inviteUser[key] = ''
        })
      }
    }

    this.submitting = false
    // @ts-ignore
    this.$refs.saveButton.finish()
  }

  validate () {
    // Validate Email
    const emailRegex = /^\w+([\+\'.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/
    const email = this.inviteUser.newUsersEmail.trim()
    if (email.length === 0) {
      this.$set(this.errors, 'newUsersEmail', 'This is a required field')
    } else if (!emailRegex.test(email)) {
      this.$set(this.errors, 'newUsersEmail', 'This is an invalid email address')
    } else {
      this.$set(this.errors, 'newUsersEmail', false)
    }
    // Validate first name
    if (this.inviteUser.newUsersFirstName.trim().length === 0) {
      this.$set(this.errors, 'newUsersFirstName', 'This is a required field')
    } else if (/([^a-z0-9-. 'àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ])/ig.test(this.inviteUser.newUsersFirstName)) {
      this.$set(this.errors, 'newUsersFirstName', 'Name cannot include special characters')
    } else {
      this.$set(this.errors, 'newUsersFirstName', false)
    }

    // Validate last name
    if (this.inviteUser.newUsersLastName.trim().length === 0) {
      this.$set(this.errors, 'newUsersLastName', 'This is a required field')
    } else if (/([^a-z0-9-. 'àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ])/ig.test(this.inviteUser.newUsersLastName)) {
      this.$set(this.errors, 'newUsersLastName', 'Name cannot include special characters')
    } else {
      this.$set(this.errors, 'newUsersLastName', false)
    }
    return !this.errors.newUsersEmail && !this.errors.newUsersFirstName && !this.errors.newUsersLastName
  }
}
